import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const AlertDetails = ({ alert, onResolve, onEscalate, onAssign, onAddComment }) => {
  const [comment, setComment] = useState('');
  const [assignStaff, setAssignStaff] = useState('');

  const staffOptions = [
    { value: 'staff_1', label: 'سارة أحمد' },
    { value: 'staff_2', label: 'أحمد محمد' },
    { value: 'staff_3', label: 'محمد خالد' },
    { value: 'staff_4', label: 'فاطمة علي' }
  ];

  const handleAddComment = () => {
    if (comment?.trim()) {
      onAddComment?.(alert?.id, {
        author: 'الموظف الحالي',
        text: comment
      });
      setComment('');
    }
  };

  const handleAssign = () => {
    if (assignStaff) {
      onAssign?.(alert?.id, assignStaff);
      setAssignStaff('');
    }
  };

  if (!alert) {
    return (
      <div className="bg-card rounded-lg border border-border shadow-warm p-8 text-center">
        <Icon name="Bell" size={48} className="mx-auto mb-4 text-muted-foreground opacity-50" />
        <p className="text-muted-foreground">اختر تنبيهاً لعرض التفاصيل</p>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg border border-border shadow-warm">
      <div className="p-4 border-b border-border">
        <h3 className="text-base font-heading font-semibold text-foreground flex items-center gap-2">
          <Icon name="FileText" size={18} />
          تفاصيل التنبيه
        </h3>
      </div>

      <div className="p-4 space-y-4 max-h-[600px] overflow-y-auto">
        {/* Alert Info */}
        <div>
          <h4 className="text-sm font-semibold text-foreground mb-2">{alert?.title}</h4>
          <p className="text-sm text-muted-foreground">{alert?.description}</p>
        </div>

        {/* Alert Metadata */}
        <div className="bg-muted rounded-lg p-3 space-y-2">
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">رقم التنبيه:</span>
            <span className="font-medium text-foreground">{alert?.id}</span>
          </div>
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">الأولوية:</span>
            <span className="font-medium text-foreground">
              {alert?.priority === 'urgent' ? 'عاجل' : alert?.priority === 'high' ? 'عالية' : alert?.priority === 'medium' ? 'متوسطة' : 'منخفضة'}
            </span>
          </div>
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">الحالة:</span>
            <span className="font-medium text-foreground">
              {alert?.status === 'unread' ? 'غير مقروء' : alert?.status === 'acknowledged' ? 'تم الاطلاع' : alert?.status === 'in_progress' ? 'قيد التنفيذ' : 'مقروء'}
            </span>
          </div>
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">موكل إلى:</span>
            <span className="font-medium text-foreground">{alert?.assignedTo}</span>
          </div>
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">تاريخ الإنشاء:</span>
            <span className="font-medium text-foreground">{alert?.createdAt}</span>
          </div>
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">تاريخ الاستحقاق:</span>
            <span className="font-medium text-foreground">{alert?.dueDate}</span>
          </div>
        </div>

        {/* Related Info */}
        {(alert?.clientName || alert?.propertyTitle || alert?.contractNumber) && (
          <div className="border-t border-border pt-4">
            <h5 className="text-sm font-semibold text-foreground mb-2">معلومات ذات صلة</h5>
            <div className="space-y-2">
              {alert?.clientName && (
                <div className="flex items-center gap-2 text-sm">
                  <Icon name="User" size={14} className="text-primary" />
                  <span className="text-muted-foreground">العميل:</span>
                  <span className="font-medium text-foreground">{alert?.clientName}</span>
                </div>
              )}
              {alert?.propertyTitle && (
                <div className="flex items-center gap-2 text-sm">
                  <Icon name="Home" size={14} className="text-primary" />
                  <span className="text-muted-foreground">العقار:</span>
                  <span className="font-medium text-foreground">{alert?.propertyTitle}</span>
                </div>
              )}
              {alert?.contractNumber && (
                <div className="flex items-center gap-2 text-sm">
                  <Icon name="FileText" size={14} className="text-primary" />
                  <span className="text-muted-foreground">العقد:</span>
                  <span className="font-medium text-foreground">{alert?.contractNumber}</span>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Comments */}
        <div className="border-t border-border pt-4">
          <h5 className="text-sm font-semibold text-foreground mb-3 flex items-center gap-2">
            <Icon name="MessageSquare" size={16} />
            التعليقات ({alert?.comments?.length})
          </h5>
          {alert?.comments?.length > 0 ? (
            <div className="space-y-2 mb-3">
              {alert?.comments?.map((c) => (
                <div key={c?.id} className="bg-muted rounded-lg p-3">
                  <div className="flex items-center justify-between mb-1">
                    <span className="text-xs font-medium text-foreground">{c?.author}</span>
                    <span className="text-xs text-muted-foreground">{c?.date}</span>
                  </div>
                  <p className="text-sm text-foreground">{c?.text}</p>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-xs text-muted-foreground mb-3">لا توجد تعليقات بعد</p>
          )}
          <div className="space-y-2">
            <Input
              type="text"
              placeholder="أضف تعليقاً..."
              value={comment}
              onChange={(e) => setComment(e?.target?.value)}
            />
            <Button variant="outline" size="sm" fullWidth onClick={handleAddComment} disabled={!comment?.trim()}>
              إضافة تعليق
            </Button>
          </div>
        </div>

        {/* Assignment */}
        <div className="border-t border-border pt-4">
          <h5 className="text-sm font-semibold text-foreground mb-3 flex items-center gap-2">
            <Icon name="UserPlus" size={16} />
            إعادة التوكيل
          </h5>
          <div className="space-y-2">
            <Select
              options={staffOptions}
              value={assignStaff}
              onChange={setAssignStaff}
              placeholder="اختر موظفاً"
            />
            <Button variant="outline" size="sm" fullWidth onClick={handleAssign} disabled={!assignStaff}>
              توكيل الموظف
            </Button>
          </div>
        </div>

        {/* Actions */}
        <div className="border-t border-border pt-4 space-y-2">
          <Button
            variant="success"
            fullWidth
            iconName="CheckCircle"
            onClick={() => onResolve(alert?.id)}
          >
            حل التنبيه
          </Button>
          <Button
            variant="warning"
            fullWidth
            iconName="AlertTriangle"
            onClick={() => onEscalate(alert?.id)}
          >
            تصعيد للمشرف
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AlertDetails;